export default __webpack_public_path__ + "static/banner-travel-long-holidays-c33b16eab4f1fbf97d5ff22c86037069.jpg";